/**
* 模版
**/

<template>
  <div style="width: 1200px; margin: 30px auto" v-loading="loading">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      class="demo-ruleForm shopCartBox"
    >
      <el-form-item>
        <el-row class="tableTitle">
          <el-col :span="4">
            <div class="grid-content">
              <el-checkbox
                :indeterminate="indeterminate"
                v-model="ischeckAll"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
            </div>
          </el-col>
          <el-col :span="6"
            ><div class="grid-content bg-purple-light">商品名称</div></el-col
          >
          <el-col :span="4"
            ><div class="grid-content bg-purple">单价</div></el-col
          >
          <el-col :span="6"
            ><div class="grid-content bg-purple-light">数量</div></el-col
          >
          <el-col :span="2"
            ><div class="grid-content bg-purple">小计</div></el-col
          >
          <el-col :span="2"
            ><div class="grid-content bg-purple-light">操作</div></el-col
          >
        </el-row>
        <div
          class="shopCard"
          v-for="(partition, partitionIndex) in list"
          :key="partitionIndex"
        >
          <div class="shopstoreItem">
            <el-row>
              <el-col :span="24">
                <div class="storeTitle grid-content">
                  <el-checkbox
                    :indeterminate="partition.indeterminate"
                    v-model="partition.checked"
                    @change="
                      handleCheckedCountryAllChange(
                        partitionIndex,
                        partition.bxmId,
                        $event
                      )
                    "
                    :key="partitionIndex"
                  >
                    {{ partition.name }}
                  </el-checkbox>
                </div>
              </el-col>
            </el-row>
            <div class="storeContent">
              <div class="coverLayerFather" v-for="(item, index) in partition.goods" :key="index">
                <div v-if="item.status!=1?true:false" class="coverLayer"></div>
                <el-row class="shopitem">
                  <el-col :span="4">
                    <div class="grid-content bg-purple-light">
                      <el-checkbox
                      v-if="item.status==1?true:false"
                        v-model="item.checked"
                        @change="
                          handleCheckedCountryChange(
                            index,
                            item.scid,
                            partition.bxmId,
                            $event
                          )
                        "
                        :key="item.id"
                        ><el-image
                            class="goodsPhotos"
                          :src="`${item.photos}`"
                        ></el-image
                      ></el-checkbox>
                      <div style="color:#F56C6C">{{item.status!=1?'此件商品已失效或下架':''}}</div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="grid-content bg-purple-light goodsname">
                      <div class="addIconBox" v-if="item.bxyMarketing!=null">
                        <span class="addIcon" v-if='item.bxyMarketing.activityTypeId==2'>参加限时折扣</span>
                        <span class="addIcon" v-if='item.bxyMarketing.activityTypeId==6'>参加限时秒杀</span>
                        <span class="addIcon" v-if='item.bxyMarketing.activityTypeId==1'>参加加价购</span>
                        <span class="addIcon" v-if='item.bxyMarketing.activityTypeId==3'>参加满即送</span>
                        <span class="addIcon" v-if='item.bxyMarketing.activityTypeId==4'>参加积分兑换</span>
                        <span class="addIcon" v-if='item.bxyMarketing.activityTypeId==5'>参加满减</span>
                      </div>
                      <span style="cursor: pointer;" @click="$router.push(`/goodsdetail?id=${item.id}`)">{{ item.name }}</span>
                      <span style="cursor: pointer;color:#ff6700;font-size:12px">{{item.cartSpecificationDetails!=null? item.cartSpecificationDetails.attributeContent:'默认规格' }}</span>
                    </div>
                    <!-- <div style="color:#F56C6C;padding: 0 20px;">{{item.status!=1?'此件商品已失效或下架':''}}</div> -->
                  </el-col>
                  <el-col :span="3"
                    ><div class="grid-content bg-purple-light">
                      <span> {{item.realprice || 0}}</span>
                      <!-- <span>{{ (item.price!=null && item.price!='')?item.price: item.marketprice }}</span>  -->
                    </div></el-col
                  >
                  <el-col :span="6">
                    <div class="grid-content bg-purple-light">
                      <el-form-item prop="number">
                        <el-input-number
                          v-model="item.number"
                          @change="
                            handleNumChange($event,partition.bxmId, item.scid, item.number,item.status,item.approvalStatus,item.cartSpecificationDetails.stock)
                          "
                          :min="1"
                          :max="item.cartSpecificationDetails?Number(item.cartSpecificationDetails.stock):Number(item.stock)"
                          label="数量"
                        ></el-input-number>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="3">
                    <div class="grid-content bg-purple-light">
                      <span class="totalNum">
                        {{  Number(item.number * item.realprice).toFixed(2) }} 元
                        <!-- {{ item.number * ((item.price!=null && item.price!="")?item.price: item.marketprice) }} 元 -->
                      </span>
                    </div>
                  </el-col>
                  <el-col :span="2">
                    <div class="grid-content bg-purple-light">
                      <el-button
                        type="danger"
                        size="mini"
                        @click="onDelete(partition.bxmId, item.scid)"
                        >删除</el-button
                      >
                    </div>
                  </el-col>
                </el-row>
                <!-- 满即赠商品 activityType==3-->
                <div v-if="item.bxyCarPromotion != null">
                  <div class="shopitem getGoodsBox" v-for="(fullGoodsItem) in item.bxyCarPromotion.addgoods" :key="fullGoodsItem.goodid">
                    <el-row style="background: #e6e6e6;" v-if="fullGoodsItem.selectdata&&item.bxyCarPromotion.activityType==3">
                    <!-- <el-row style="background: #e6e6e6;" v-if="fullGoodsItem.selectdata&item.bxyCarPromotion.activityType==3"> -->
                        <el-col :span="4">
                          <div class="grid-content imgRight">
                              <el-image class="goodsPhotos" :src="fullGoodsItem.goodphoto" ></el-image>
                              <div style="color:#F56C6C">{{item.status!=1?'此件商品已失效或下架':''}}</div>
                          </div>
                       </el-col>
                       <el-col :span="15"><div class="goodsname">
                          <div class="activityType"><span>赠品</span></div>
                          <span style="cursor: pointer;">{{fullGoodsItem.goodname }}</span>
                          <div class="activityType" style="cursor:pointer"><a href="javascript:;"  @click="selectGoods(item.bxyCarPromotion.addgoods,partitionIndex,index)">选择其他赠品</a></div>
                          </div>
                          <div style="color:#F56C6C;padding: 0 20px;">{{item.status!=1?'此件商品已失效或下架':''}}</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="grid-content">
                          <span class="totalNum">
                            {{ 0 }} 元
                          </span>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                 <!-- 满即赠商品 activityType==3-->

                  <!-- 加购价商品 activityType==1 开始-->
                <div v-if="item.bxyCarPromotion != null" >
                  <!-- <div class="shopitem getGoodsBox" v-for="(addPriceGoodsItem) in item.bxyCarPromotion.addfeegoods" :key="addPriceGoodsItem.goodid"> -->
                  <!-- <div class="shopitem getGoodsBox" v-for="(addPriceGoodsItem) in addPriceSelectList" :key="addPriceGoodsItem.specificationid"> -->
                  <div v-for="(addPriceGoodsItem,collectPriceGoodsIndex) in collectAddPriceList" :key="collectPriceGoodsIndex">
                      <div class="shopitem getGoodsBox" v-if="addPriceGoodsItem.mainGoodsId==item.cartSpecificationDetails.id">
                      <el-row v-if="addPriceGoodsItem.selectdata&&item.bxyCarPromotion.activityType==1" style="background:#e6e6e6">
                          <el-col :span="4">
                            <div class="grid-content imgRight">
                                <el-image class="goodsPhotos" :src="addPriceGoodsItem.goodphoto" ></el-image>
                                <div style="color:#F56C6C">{{item.status!=1?'此件商品已失效或下架':''}}</div>
                            </div>
                          </el-col>
                          <el-col :span="6">
                            <div class="goodsname">
                              <div class="activityType"><span>加价购</span></div>
                              <span>{{addPriceGoodsItem.goodname }}</span>
                            </div>
                            <div style="color:#F56C6C;padding: 0 20px;">{{item.status!=1?'此件商品已失效或下架':''}}</div>
                          </el-col>
                          <el-col :span="3">
                            <div class="grid-content bg-purple-light">
                              <span class="">
                                {{  Number(addPriceGoodsItem.goodprice).toFixed(2) }} 元
                              </span>
                            </div>
                          </el-col>
                          <el-col :span="6">
                            <div class="grid-content bg-purple-light">
                              <el-form-item prop="number">
                                <el-input-number
                                  v-model="item.number"
                                  @change="
                                    handleNumChange(partition.bxmId, item.scid, item.number)
                                  "
                                  :min="1"
                                  :max="1"
                                  label="数量"
                                ></el-input-number>
                              </el-form-item>
                            </div>
                          </el-col>
                          <el-col :span="3">
                            <div class="grid-content">
                              <span class="totalNum">
                                {{addPriceGoodsItem.goodprice}} 元
                              </span>
                            </div>
                          </el-col>
                          <el-col :span="2">
                            <div class="grid-content bg-purple-light">
                              <el-button
                                type="danger"
                                size="mini"
                                @click="addPriceDelete(addPriceGoodsItem)"
                                >删除</el-button
                              >
                            </div>
                          </el-col>
                    </el-row>
                  </div>
                  </div>
                  <div v-if="item.bxyCarPromotion.activityType==1">
                    <!-- <el-row class="addPriceGoods" v-if="(addPriceSelectList.length==item.bxyCarPromotion.addfeegoods.length)?false:true">                     -->
                    <el-row class="addPriceGoods" v-if="collectAddPriceList.length==0||(item.bxyCarPromotion.addfeegoods[fullGiftradio].selectdata==true?false:true)">
                        <el-col :span="24">
                          <i class="el-icon-circle-plus"></i>
                          <span @click="addPriceClick(item.bxyCarPromotion.addfeegoods,partitionIndex,index,item.bxyCarPromotion.addfeegoodsNum,item)">可选择加价购商品 <i v-if="item.bxyCarPromotion.addfeegoods.length>1">（多版本可选）</i></span>
                          <!-- <span @click="addPriceClick(item.bxyCarPromotion.addfeegoods,partitionIndex,index,item.bxyCarPromotion.addfeegoodsNum)">{{item.bxyCarPromotion.addfeegoods[0].goodname}} <i v-if="item.bxyCarPromotion.addfeegoods.length>1">（多版本可选）</i></span> -->
                      </el-col>
                  </el-row>
                  </div>
                </div>
                 <!-- 加购价商品 activityType==1 结束-->

                  <!-- 满减 activityType==5 开始  -->
                  <div class="shopitem fullReduceBox" v-if="item.bxyCarPromotion!=null?true:false">
                    <el-row v-if="item.bxyCarPromotion.activityType==5">
                       <el-col :span="1">
                         <div class="grid-content tick">
                            <span style="cursor: pointer;">√</span>
                         </div>
                      </el-col>
                        <el-col :span="3">
                          <div class="grid-content imgRight">
                              <div class="goodsPhotos" ></div>
                          </div>
                       </el-col>
                       <el-col :span="6"><div class="goodsname grid-content">
                          <span style="cursor: pointer;">活动优惠</span>
                          </div>
                      </el-col>
                       <el-col :span="4">
                        <div class="grid-content">
                          <span class="">
                            -{{ item.bxyCarPromotion.cutfee||0 }}
                          </span>
                        </div>
                      </el-col>
                       <el-col :span="5">
                        <div class="grid-content">
                          <span class="">
                            1
                          </span>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="grid-content">
                          <span class="totalNum">
                            -{{ item.bxyCarPromotion.cutfee||0 }}
                          </span>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                 <!-- 满减 activityType==5 结束-->

              </div>
            </div>
          </div>
        </div>
        <div v-if="list.length==0?true:false" class="gotoShop">
             <p>您的进货单还是空的!</p>
             <router-link class="gotoShopText" to="/goodsList">马上去购物</router-link>
          </div>
      </el-form-item>
    </el-form>
    <div class="bottomCount">
      <el-row :class="searchBarFixed == true ? 'isFixed' : ''">
        <el-col :span="6"
          ><div class="grid-content">
            <router-link to="/goodsList">继续购物</router-link>
          </div></el-col
        >
        <el-col :span="6"
          ><div class="grid-content totalNum">
            共 <strong>{{ status()[0] }}</strong> 件商品，已选择
            <strong>{{ status()[1] }}</strong> 件
          </div></el-col
        >
        <el-col :span="6"
          ><div class="grid-content totalNum">
            合计(不含运费):<strong class="totalSize">{{ sumPrice() }}</strong
            >元
          </div></el-col
        >
        <el-col :span="6"
          ><div class="grid-content">
            <el-button
              class="countedSize"
              type="danger"
              size=""
              @click="submitForm('ruleForm')"
              :disabled="status()[2]"
              >去结算</el-button
            >
          </div></el-col
        >
      </el-row>
    </div>

    <!-- 满即赠弹框选择商品 -->
    <el-dialog
      class="fullGiftBox"
      :visible.sync="fullGiftDialogVisible"
      width="60%"
      center
      title="选择满即赠产品"
      :close-on-click-modal=false
    >
      <div style="text-align: center">
         <el-radio-group v-model="fullGiftradio">
           <el-radio v-for="(item,index) in fullGiftList" :key="item.goodid" :label="index">
            <div>
              <div class="p-img">
                  <el-image  class="xunyouText" :src="item.goodphoto">
                      <div slot="error" class="image-slot bg-font-size-big">
                          <i class="el-icon-picture"></i>
                      </div>
                  </el-image>
              </div>
              <div class="pro_name goodsname">{{item.goodname}}</div>
            </div>
         </el-radio>
        </el-radio-group>
         <div slot="footer" class="dialog-footer">
           <el-button type="primary" class="buttonBgd" @click="fullGoodaddCart">加入进货单</el-button>
         </div>
      </div>
    </el-dialog>

     <!-- 加价购弹框选择商品 -->
    <el-dialog
      class="fullGiftBox"
      :visible.sync="addPriceDialogVisible"
      width="60%"
      center
      title="选择加购产品"
      :close-on-click-modal=false
    >
      <div style="text-align: center">
         <el-radio-group v-model="fullGiftradio">
           <el-radio v-for="(item,index) in addPriceList" :key="item.specificationid" :label="index">
            <div>
              <div class="p-img">
                  <el-image  class="xunyouText" :src="item.goodphoto">
                      <div slot="error" class="image-slot bg-font-size-big">
                          <i class="el-icon-picture"></i>
                      </div>
                  </el-image>
              </div>
              <div class="pro_name goodsname">{{item.goodname}}</div>
            </div>
         </el-radio>
        </el-radio-group>
         <div slot="footer" class="dialog-footer">
           <el-button type="primary" @click="addPriceaddCart()">加入进货单</el-button>
         </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { shoppingCartlist,shoppingCartDelete,editCartNumber  } from "@/api/xunyou";

// scid: 进货单的id  每条记录都不一样唯一（同一个商品加两次）
// cid 商品id
// 导出模块
export default {
  // 模块名字
  name: "",
  // 模块数据
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      searchBarFixed: true, // 监听滚动条
      loading: false,
      ruleForm: {
        type: [],
        number: 1,
      },
      rules: {
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
      },
      total: 0,
      list:[],
      ischeckAll: false,
      indeterminate: false,
      // 满即送
      oldList:[],// 记录原来的数组
      fullGiftList:[],
      fullGiftDialogVisible:false, // 满即赠弹框
      fullGiftradio:0,
      selectFullGoodsFlag:false,// 是否有打开选择满即送商品
      // fullGoodsIndex:0,
      // fullGiftListSelect:{},
      // selectItem:{},
      // 加价购
      addPriceDialogVisible:false,
      addPriceradio:0,
      addPriceList:[],
      collectAddPriceList:[],
      addPriceSelectList:[],
      addpriceNumber:1,
      rules: {
        senderName: [
          { required: true, message: "字段不能为空", trigger: "blur" },
        ],
        website: [{ required: true, message: "字段不能为空", trigger: "blur" }],
      },
    };
  },
  // 注册组件
  components: {
    // headerComponent
  },
  // 监听指定值，只有指定值变化，才会触发
  watch: {},
  mounted() {
    if(this.userInfo.loginName!=null||this.userInfo.loginName!="" ){
          this.getshoppingCartlist();
    }

    //   window.addEventListener('scroll', this.handleScroll,true)
  },
  // 销毁完成状态(里面是操作)
  destroyed() {
    //    window.removeEventListener('scroll', this.handleScroll,true)
  },
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {

    // 满即送商品选择 第一步
    selectGoods(item,partitionIndex,index,selectItem){
      this.fullGiftDialogVisible = true
      this.fullGiftList = item
      this.partitionIndex = partitionIndex
      this.goodsIndex = index
    },
    // 满即送商品选择 第二步
    fullGoodaddCart(){
      this.list[this.partitionIndex].goods[this.goodsIndex].bxyCarPromotion.addgoods.forEach((item,index)=>{
        item.selectdata=false;
      })
      this.list[this.partitionIndex].goods[this.goodsIndex].bxyCarPromotion.addgoods[this.fullGiftradio].selectdata=true;
      this.fullGiftDialogVisible = false
    },

    // 加购价格 第一步
    addPriceClick(item,partitionIndex,index,number=1,goodsId){
      console.log(item,partitionIndex,index,number,'加购价格 第一步')
      item.forEach((selcetItem)=>{
        selcetItem.mainGoodsId = goodsId.cartSpecificationDetails?goodsId.cartSpecificationDetails.id:goodsId.id
      })
      // item[0].mainGoodsId = goodsId.cartSpecificationDetails?goodsId.cartSpecificationDetails.id:goodsId.id
      this.addPriceDialogVisible = true
      this.addPriceList=item
      this.partitionIndex = partitionIndex
      this.goodsIndex = index
      this.addpriceNumber = number
      if(this.addPriceSelectList.length>0){ // 判断进货单中有几个加购商品
            this.addPriceSelectList.forEach((addItem,addindex)=>{
              if(addItem.mainGoodsId!=item[addindex].mainGoodsId){ // 同一个商品 不同规格参加同一加价购活动，加价购的物品是一样的
                 if(addItem.specificationid!=item[addindex].specificationid){
                  this.addPriceSelectList.push(item)
                }
              } else{
                 if(addItem.specificationid!=item[addindex].specificationid){
                  this.addPriceSelectList.push(item)
                }
              }
            })
      }else{
        this.addPriceSelectList.push(item)
      }
    },
       // 加购价格 第二步
    addPriceaddCart(){
      //debugger
      this.collectAddPriceList = this.addPriceSelectList
      if(this.collectAddPriceList.length>0){ // 先判断选择加价购商品有几个
          if(this.addpriceNumber>1){ // 根据后台传过来的数量限制加价购商品的类型
              this.collectAddPriceList.forEach((item,index)=>{ // 对比加价购商品的是否有相同的，不相同就加入选择
              if(item.specificationid != this.addPriceList[this.goodsIndex][this.fullGiftradio].specificationid){
                let newObj =  this.list[this.partitionIndex].goods[this.goodsIndex].bxyCarPromotion.addfeegoods[this.fullGiftradio]
                newObj.selectdata=true;
                this.collectAddPriceList.push(newObj)
              }else{
                this.$message.error("不能选择相同商品");
              }
            })
          }else{
            this.list[this.partitionIndex].goods[this.goodsIndex].bxyCarPromotion.addfeegoods.forEach((item)=>{
              item.selectdata = false
            })
            this.collectAddPriceList[this.goodsIndex]=this.list[this.partitionIndex].goods[this.goodsIndex].bxyCarPromotion.addfeegoods[this.fullGiftradio]
            // debugger
            // this.collectAddPriceList[this.goodsIndex].selectdata=true;
            this.collectAddPriceList[this.goodsIndex].selectdata=true;
          }
      }else{
        this.collectAddPriceList[this.goodsIndex]=this.list[this.partitionIndex].goods[this.goodsIndex].bxyCarPromotion.addfeegoods[this.fullGiftradio]
        // this.collectAddPriceList[this.goodsIndex].selectdata=true;
        this.collectAddPriceList[this.goodsIndex].selectdata=true;
      }
      this.addPriceDialogVisible = false
    },

    // // 加购价格 第二步
    // addPriceaddCart(){
    //   if(this.addPriceSelectList.length>0){ // 先判断选择加价购商品有几个
    //   console.log(this.addPriceSelectList,this.collectAddPriceList,'=================加价购=================')
    //       if(this.addpriceNumber>1){ // 根据后台传过来的数量限制加价购商品的类型
    //           this.addPriceSelectList.forEach((item,index)=>{ // 对比加价购商品的是否有相同的，不相同就加入选择
    //           if(item.goodid != this.addPriceList[this.goodsIndex][this.fullGiftradio].goodid){
    //             let newObj =  this.list[this.partitionIndex].goods[this.goodsIndex].bxyCarPromotion.addfeegoods[this.fullGiftradio]
    //             newObj.selectdata=true;
    //             this.addPriceSelectList.push(newObj)
    //           }else{
    //             this.$message.error("不能选择相同商品");
    //           }
    //         })
    //       }else{
    //         this.list[this.partitionIndex].goods[this.goodsIndex].bxyCarPromotion.addfeegoods.forEach((item)=>{
    //           item.selectdata = false
    //         })
    //         this.addPriceSelectList[0]=this.list[this.partitionIndex].goods[this.goodsIndex].bxyCarPromotion.addfeegoods[this.fullGiftradio]
    //         // debugger
    //         // this.addPriceSelectList[this.goodsIndex].selectdata=true;
    //         this.addPriceSelectList[0].selectdata=true;
    //       }
    //   }else{
    //     this.addPriceSelectList[0]=this.list[this.partitionIndex].goods[this.goodsIndex].bxyCarPromotion.addfeegoods[this.fullGiftradio]
    //     // this.addPriceSelectList[this.goodsIndex].selectdata=true;
    //     this.addPriceSelectList[0].selectdata=true;
    //   }
    //   this.addPriceDialogVisible = false
    // },



    // 删除加价购商品 --- 需要审查测试
    addPriceDelete(itemDelete){
      this.collectAddPriceList = this.collectAddPriceList.filter((item) =>{
        if(item.specificationid == itemDelete.specificationid){
          item.selectdata=false;
        }
        return item.specificationid != itemDelete.specificationid

      });
    },

  // 数量加减
    onAddCar(scid,number,status,approvalStatus,stock){
        if(stock>0){
          if(this.userInfo.loginName==null||this.userInfo.loginName=="" ){
            this.$router.push('/login')
            return
          }
          if(status==1&&approvalStatus==1){
          editCartNumber({
            scid:scid,
            number:number,
          })
            .then((res) => {
              console.log(res)
                if (res.code == 0) {
                  this.addDialogVisible = true;
                  this.getshoppingCartlist()
                  return
                }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("数量修改失败，请稍后再试！");
            });
          }else{
            this.$message.error('暂时缺货')
            return
          }
        }else{
          this.$message({
            type:'error',
            message:'商品库存不足,请联系卖家！'
          })
        }
      },


    //   监听滚动条(判断有问题)
    handleScroll() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;

      // 避免没有数据的时候 重复执行 scrollHeight > clientHeight
      if (
        scrollHeight > clientHeight &&
        scrollTop + clientHeight === scrollHeight
      ) {
        this.searchBarFixed = false;
      } else {
        this.searchBarFixed = true;
      }
    },
    // 进货单查询
    getshoppingCartlist() {
      this.loading = true;
      shoppingCartlist({uid:this.userInfo.userId||''})
        .then((res) => {
          if (res.length> 0) {
              this.$store.commit('getCartList',res)
          }
          //   if (res.code == 0) {
          console.log("res", res);
          this.loading = false;
          let newList = res.map((x)=>{
            return x.bxunyouMerchant;
          })
          this.list = newList;
          //   } else {
          // this.$message({
          //   type: 'info',
          //   message: res.msg
          // })
          //   }
          if(this.ischeckAll){
              this.handleCheckAllChange(this.ischeckAll)
          }else{
            this.indeterminate = false
          }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("查询进货单失败，请稍后再试！");
        });
    },
    // 选择状态判断
    status() {
      let allProduct = 0;
      let selectProduct = 0;
      this.list.forEach((x) => {
        if (x && x.goods.length) {
          allProduct= allProduct + x.goods.length;
          x.goods.forEach((items) => {
            if (items.checked) {
            //  this.addPriceSelectList.length>0? this.addPriceSelectList.forEach((item)=>{ //collectAddPriceList
             this.collectAddPriceList.length>0? this.collectAddPriceList.forEach((item)=>{ //collectAddPriceList
                  selectProduct+= 1;
              }):''
              selectProduct += 1;
            }
             allProduct+=(items.bxyCarPromotion!=null?items.bxyCarPromotion.addfeegoods.length:0)
          });
        }
      });
      let isSelect = selectProduct === 0;
      return [allProduct, selectProduct, isSelect];
    },
    // 总计
    sumPrice() {
      let total = 0;
      this.list.forEach((items) => {
        if (items && items.goods) {
          let sum = items.goods.reduce((sum, item) => {
            if (item.checked && item.status==1) { // 判断是否已经选择
              //  this.addPriceSelectList.length>0?this.addPriceSelectList.forEach((addPriceitem)=>{ //collectAddPriceList
               this.collectAddPriceList.length>0?this.collectAddPriceList.forEach((addPriceitem)=>{ //collectAddPriceList
                var result = item.bxyCarPromotion!=null?item.bxyCarPromotion.addfeegoods.some(addfeeitem=>{
                  if(addPriceitem.specificationid==addfeeitem.specificationid){
                      return true
                  }
                }):false
                if(result&&addPriceitem.selectdata){
                  sum = sum + Number(addPriceitem.goodprice)
                }
              }):''
              if(item.bxyCarPromotion!=null && item.bxyCarPromotion.activityType==5){
                sum-=Number(item.bxyCarPromotion.cutfee)
              }
              return sum + item.realprice * item.number; // 隐式转换
            } else {
              return sum + 0;
            }
          }, 0);
          total += sum;
        }
      });
      return total.toFixed(2);
    },
    // 删除 进货单里普通商品
    onDelete(bxmId, id) {
      console.log(bxmId, id);
    //   // 前端删除
    //   this.list.forEach((x) => {
    //     if (x.bxmId === bxmId) {
    //       for (let i = x.goods.length - 1; i >= 0; i--) {
    //         try {
    //           if (x.goods[i].id === id) {
    //             x.goods.splice(i, 1);
    //           }
    //           throw new Error("EndIterative");
    //         } catch (e) {
    //           if (e.message != "EndIterative") throw e;
    //         }
    //       }
    //     }
    //   });
    //   for (let i = this.list.length - 1; i >= 0; i--) {
    //     try {
    //       if (this.list[i].goods.length === 0) {
    //         this.list.splice(i, 1);
    //       }
    //       throw new Error("EndIterative");
    //     } catch (e) {
    //       if (e.message != "EndIterative") throw e;
    //     }
    //   }
      // // 后端删除
      shoppingCartDelete({
        ids:id
      }).then((res) => {
          console.log(res)
          if(res.code === 0){
            this.getshoppingCartlist();
            this.$message.success({
              type:'success',
              message:"删除成功！"
            });
            this.$router.go(0)
          }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("删除失败，请稍后再试！");
        });
    },
    // 改变数量 实时计算
    handleNumChange($event,bxmId, id,number,status,approvalStatus,stock) {
      this.list.forEach((x) => {
        if (x.bxmId === bxmId) {
          x.goods.forEach((items) => {
            if (items.scid === id) {
              items.number = number;
            }
          })
        }
      });
      this.onAddCar(id,number,status,approvalStatus,stock)
      this.$store.commit('getCartList',this.list)
    },
    // 提交
    submitForm(formName) {
      console.log(this.list)
      let selectList = [];
     this.list.forEach((x)=>{
        //    if(x.checked){
        let canPush = false;
           let obj = {};
        let goodList = [];
                x.goods.forEach((items)=>{
                    if(items.checked && items.status==1){
                          canPush = true;
                          let child = {
                          ...items
                          }
                        goodList.push(child)
                    }
                })

        obj = {
        ...x,
        goods:goodList

        }
        if(canPush){
        selectList.push(obj)
        }
        //    }
        })
     sessionStorage.setItem("selectList", JSON.stringify(selectList));
      this.$router.push('/orderDetail')
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleCheckAllChange(e) {
      //一级change事件
      this.ischeckAll = e;
      this.indeterminate = false;
      for (var i = 0, len = this.list.length; i < len; i++) {
        //二级全选反选
        this.list[i].checked = e;
        this.list[i].indeterminate = false; //去掉二级不确定状态
        for (var j = 0, len1 = this.list[i].goods.length; j < len1; j++) {
          //三级全选反选
          this.list[i].goods[j].checked = e;
        }
      }
    },
    handleCheckedCountryAllChange(index, topId, e) {
      //二级change事件
      this.list[index].checked = e; //二级勾选后，子级全部勾选或者取消
      this.list[index].indeterminate = false; //去掉二级不确定状态
      var childrenArray = this.list[index].goods;
      if (childrenArray)
        for (var i = 0, len = childrenArray.length; i < len; i++)
          childrenArray[i].checked = e;

      this.getIsCheckAll();
    },
    handleCheckedCountryChange(topIndex, sonId, topId, e) {
      //三级change事件
      console.log(topIndex, sonId, topId, e,this.list,'三级change事件')
      var childrenArray = this.list[topIndex].goods;
      var tickCount = 0,
        unTickCount = 0,
        len = childrenArray.length;
      for (var i = 0; i < len; i++) {
        if (sonId == childrenArray[i].id) childrenArray[i].checked = e;
        if (childrenArray[i].checked == true) tickCount++;
        if (childrenArray[i].checked == false) unTickCount++;
      }
      if (tickCount == len) {
        //三级级全勾选
        this.list[topIndex].checked = true;
        this.list[topIndex].indeterminate = false;
      } else if (unTickCount == len) {
        //三级级全不勾选
        this.list[topIndex].checked = false;
        this.list[topIndex].indeterminate = false;
      } else {
        this.list[topIndex].checked = false;
        this.list[topIndex].indeterminate = true; //添加二级不确定状态
      }

      this.getIsCheckAll();
    },
    getIsCheckAll() {
      var tickCount = 0,
        unTickCount = 0,
        indeterminateCount = 0,
        ArrLength = this.list.length;
      for (var j = 0; j < ArrLength; j++) {
        //全选checkbox状态
        if (this.list[j].checked == true) tickCount++;
        if (this.list[j].checked == false) unTickCount++;
        if (this.list[j].indeterminate == true) indeterminateCount++;
      }
      if (tickCount == ArrLength) {
        //二级全勾选
        this.ischeckAll = true;
        this.indeterminate = false;
      } else if (unTickCount == ArrLength) {
        //二级全不勾选
        this.ischeckAll = false;
        if (indeterminateCount > 0) {
          this.indeterminate = true;
        } else {
          this.indeterminate = false;
        }
      } else {
        this.ischeckAll = false;
        this.indeterminate = true; //添加一级不确定状态
      }
    },
  },
};
</script>
<style scoped lang='less'>
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
  box-sizing: border-box;
  background: white;
}
.goodsname{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    .addIconBox{
      height: 26px;
      .addIcon{
        font-size: 12px;
        color: white;
        background: #ff6700;
        padding: 3px 10px;
        border-radius: 2px;
    }
    }

}
.shopCartBox {
  .tableTitle {
    border-bottom: 1px solid #efefef;
    .grid-content {
      padding: 0 15px;
    }
  }
  .shopstoreItem {
    margin-bottom: 40px;
    .goodsPhotos{
        width: 70px;
        height: 70px;
    }
    /deep/.el-input-number {
        vertical-align: text-top;
    }
    .coverLayerFather {
        position: relative;
        .coverLayer {
          position: absolute;
          background: #ebeef547;
          z-index: 10;
          width: 90%;
          height: 100%;
      }
    }
  }
  /deep/span.el-checkbox__label {
    vertical-align: middle;
  }
  .shopitem.el-row {
    padding: 20px;
    background: white;
    box-sizing: border-box;
    border-bottom: 1px solid #efefef;
  }
  .storeTitle.grid-content {
    border-bottom: 1px solid #efefef;
  }
   .gotoShop {
      text-align: center;
      font-size: 30px;
      margin: 40px;
      color:rgb(176, 176, 176);
      .gotoShopText{
        font-size: 14px;
        padding: 0px 8px;
        border-radius: 6px;
        box-sizing: border-box;
        border: 1px solid #ff6700;
        background: #ff6700;
        color: white;
        margin: 20px;
        display: inline-block;
      }
      .gotoShopText:hover{
        background: #ff6700c9
      }
  }
  .fullReduceBox{
    border-bottom: 1px solid #efefef;
    background: white;
    .tick{
      color: red;
      font-size: 16px;
      padding-right: 0;
      text-align: right;
    }
    .grid-content.imgRight{
      // text-align: center;
      .goodsPhotos{
        display: inline-block;
        width: 100%;
        height: 100%;
        background: url('../../assets/img/icon-activity.png') -10px -165px no-repeat;
     }
    }
  }
}
span.totalNum {
  color: #ff6700;
}
.bottomCount {
  margin-bottom: 40px;
  .isFixed {
    position: fixed;
    bottom: 0;
    left: 0%;
    width: 100%;
    margin: auto;
    z-index: 1;
  }
  .countedSize {
    width: 100%;
  }
  .totalNum {
    color: #ff6700;
    .totalSize {
      font-size: 30px;
    }
  }
}

.getGoodsBox{
  // background:#e6e6e6 !important;
  background: #e6e6e6 !important;
  padding: 20px;
  .grid-content{
    background:#e6e6e6 !important;
    line-height: 70px !important;
    height: 69px;

  }
  .imgRight {
    text-align: center;
    padding: 0 !important;
}
  .activityType{
    font-size: 12px;
    color: #ff6700;
    span{
      display: inline-block;
      background: red;
      color: #fff;
      padding: 0 18px;
      border-radius: 4px;
    }
    a{
      color: #ff6700;
    }
  }
  /deep/.goodsname{
    line-height: 23px !important;
    background: #e6e6e6;
    padding: 0 20px;
  }
}
.fullGiftBox{
  // /deep/.el-dialog{
  //   background:transparent
  // }
  button.el-button.buttonBgd.el-button--primary {
    background-color: #ff6700;
    border-color: #ff6700;
    font-size: 14px;
    margin: 20px 0;
  }
  .dialog-footer{
    margin: 30px 0;
  }
   /deep/.el-radio-group {
        width: 100%;
        height: auto;
        label.el-radio.is-checked {
            // width: 100%;
        }
    }
  .xunyouText {
      width: 120px;
      height: 120px;
  }
    .p-img{
      margin-bottom: 10px;
      // width: 150px;
      height: auto;
    }
}
.addPriceGoods{
    border: 1px solid #ccc;
    margin: 10px;
    padding: 0 20px;
    /deep/.el-radio-group {
        width: 150px;
        height: auto;
        label.el-radio.is-checked {
            width: 100%;
        }
    }
    .xunyouText {
        width: 120px;
        height: 120px;
    }
    span{
      cursor: pointer;
    }
    span:hover{
      color: #ff9147;
    }
  i.el-icon-circle-plus {
                color: #ff9a00;
                font-size: 20px;
                vertical-align: middle;
                cursor: pointer;
            }
}

// .fullGiftBox{


// }
</style>



// WEBPACK FOOTER //
// src/views/shoppingcart/shoppingcart.vue